export default function TermsConditions() {
  return (
    <div
      style={{
        backgroundColor: "#f9fafb",
        color: "#1f2937",
        fontFamily: "sans-serif",
      }}
    >
      <div style={{ maxWidth: "64rem", margin: "0 auto", padding: "2rem" }}>
        <h1
          style={{
            fontSize: "2.25rem",
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: "3rem",
            color: "#2563eb",
          }}
        >
          NuGenesis Terms and Conditions
        </h1>

        <section
          style={{
            marginBottom: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "1rem",
              color: "#1f2937",
            }}
          >
            1. Introduction
          </h2>
          <p style={{ color: "#4b5563" }}>
            Welcome to NuGenesis. By using our mobile app, you agree to comply
            with these Terms and Conditions. Please read them carefully.
          </p>
        </section>

        <section
          style={{
            marginBottom: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "1rem",
              color: "#1f2937",
            }}
          >
            2. Acceptance of Terms
          </h2>
          <p style={{ color: "#4b5563" }}>
            By accessing or using the NuGenesis app, you agree to be bound by
            these Terms and our Privacy Policy.
          </p>
        </section>

        <section
          style={{
            marginBottom: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "1rem",
              color: "#1f2937",
            }}
          >
            3. Account Registration
          </h2>
          <p style={{ color: "#4b5563" }}>
            To access certain features, you may need to create an account. You
            are responsible for maintaining the confidentiality of your account
            information.
          </p>
        </section>

        <section
          style={{
            marginBottom: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "1rem",
              color: "#1f2937",
            }}
          >
            4. Use of the App
          </h2>
          <p style={{ color: "#4b5563" }}>
            You agree to use the app in compliance with applicable laws and
            regulations. Unauthorized use, copying, or distribution of the app’s
            content is strictly prohibited.
          </p>
        </section>

        <section
          style={{
            marginBottom: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "1rem",
              color: "#1f2937",
            }}
          >
            5. Blockchain Transactions
          </h2>
          <p style={{ color: "#4b5563" }}>
            NuGenesis provides a platform for blockchain-based transactions. You
            understand and accept the inherent risks of blockchain technology,
            including volatility, cybersecurity threats, and potential
            transaction failures.
          </p>
        </section>

        <section
          style={{
            marginBottom: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "1rem",
              color: "#1f2937",
            }}
          >
            6. Gasless and Carbon-Neutral Operations
          </h2>
          <p style={{ color: "#4b5563" }}>
            Transactions on the NuGenesis blockchain are gasless and
            carbon-neutral. While we ensure operational efficiency, we are not
            responsible for any third-party charges.
          </p>
        </section>

        <section
          style={{
            marginBottom: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "1rem",
              color: "#1f2937",
            }}
          >
            7. User Responsibilities
          </h2>
          <p style={{ color: "#4b5563" }}>
            Provide accurate information, comply with regulations, and secure
            your private keys and digital assets.
          </p>
        </section>

        <section
          style={{
            marginBottom: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "1rem",
              color: "#1f2937",
            }}
          >
            8. Security and Privacy
          </h2>
          <p style={{ color: "#4b5563" }}>
            We use AI-powered security measures to protect your data, but users
            must safeguard their accounts.
          </p>
        </section>

        <section
          style={{
            marginBottom: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "1rem",
              color: "#1f2937",
            }}
          >
            9. Third-Party Services
          </h2>
          <p style={{ color: "#4b5563" }}>
            The app may integrate with third-party services. We are not
            responsible for their performance.
          </p>
        </section>

        <section
          style={{
            marginBottom: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "1rem",
              color: "#1f2937",
            }}
          >
            10. Termination
          </h2>
          <p style={{ color: "#4b5563" }}>
            We reserve the right to suspend or terminate your account if you
            violate these Terms.
          </p>
        </section>

        <section
          style={{
            marginBottom: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "1rem",
              color: "#1f2937",
            }}
          >
            11. Limitation of Liability
          </h2>
          <p style={{ color: "#4b5563" }}>
            NuGenesis shall not be liable for any damages arising from your use
            of the app.
          </p>
        </section>

        <section
          style={{
            marginBottom: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "1rem",
              color: "#1f2937",
            }}
          >
            12. Indemnification
          </h2>
          <p style={{ color: "#4b5563" }}>
            You agree to indemnify and hold NuGenesis harmless from any claims
            or expenses resulting from your use of the app.
          </p>
        </section>

        <section
          style={{
            marginBottom: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "1rem",
              color: "#1f2937",
            }}
          >
            13. Amendments
          </h2>
          <p style={{ color: "#4b5563" }}>
            We may update these Terms. Continued use of the app means you accept
            the revised Terms.
          </p>
        </section>

        <section
          style={{
            marginBottom: "2.5rem",
            padding: "1.5rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.75rem",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "1rem",
              color: "#1f2937",
            }}
          >
            14. Contact Us
          </h2>
          <p style={{ color: "#4b5563" }}>
            If you have any questions, please contact us at
            <a
              href="mailto:inquiries@nugenesisou.com"
              style={{ color: "#2563eb", textDecoration: "underline" }}
            >
              inquiries@nugenesisou.com
            </a>
            .
          </p>
        </section>

        <footer
          style={{ marginTop: "4rem", textAlign: "center", color: "#6b7280" }}
        >
          <p>&copy; 2025 NuGenesis. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
  }
  